import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { fetchDossierSubTypes, fetchStagesCombo } from '../../actions/combos/combos'
import { initializeSearch, resetFilters } from '../../actions/search/search'
import { openModal, yesNoModal } from '../../actions/common'
import { resetFiltersSelfSupplyInfo, fetchSelfSupplyInfo, fetchSelfSupplyInfoDownload, passSelfSupplyVoAction } from '../../actions/management/management'
import SelfSupplyManager from '../../components/management/SelfSupplyManager'

export function mapStateToProps (state) {
  return {
    ...state.management.selfSupplyManagementFinder,
    combos: {
      ...state.combos
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchDossierSubTypes,
      fetchStagesCombo,
      initializeSearch,
      resetFilters,
      openModal,
      yesNoModal,
      resetFiltersSelfSupplyInfo,
      fetchSelfSupplyInfo,
      fetchSelfSupplyInfoDownload,
      passSelfSupplyVoAction
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SelfSupplyManager))
